import { useTranslation } from 'react-i18next'

export function Footer() {
  const { t } = useTranslation()
  
  return (
    <footer className="bg-bg-alt dark:bg-bg border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center text-sm text-text-muted">
          <p>&copy; {new Date().getFullYear()} {t('common.appName')}. {t('common.allRightsReserved')}</p>
          <p className="mt-2">{t('common.appTagline')}</p>
        </div>
      </div>
    </footer>
  )
}